document.addEventListener('DOMContentLoaded', function() {

  var product = window.paProduct;
  if (!product) return;

  var variants = product.variants;
  var options = product.options; // ['Metal','Grosor'] o ['Metal','Grosor','Origen'] o ['Metal','Talla','Origen']

  // Estado actual: array de valores seleccionados por posición (0-indexed)
  var selected = variants[0]
    ? [variants[0].option1, variants[0].option2, variants[0].option3].filter(Boolean)
    : [];

  // ── Colores de metal ──
  var metalColors = {
    'blanco': '#C8D4DC',
    'amarillo': '#D4A820',
    'platino': '#E2E2E2',
    'rosado': '#E8B4B8'
  };

  // Aplicar color a swatches
  document.querySelectorAll('[data-metal-color]').forEach(function(sw) {
    var slug = sw.dataset.metalColor.toLowerCase();
    for (var key in metalColors) {
      if (slug.indexOf(key) !== -1) {
        sw.style.background = metalColors[key];
        break;
      }
    }
  });

  // ── Encontrar variante por opciones seleccionadas ──
  function findVariant(sel) {
    return variants.find(function(v) {
      var opts = [v.option1, v.option2, v.option3].filter(Boolean);
      return opts.every(function(o, i) { return sel[i] === o; });
    }) || null;
  }

  // ── Actualizar precio y variant ID ──
  function updatePrice(variant) {
    var priceEl = document.getElementById('pa-price');
    var originEl = document.getElementById('pa-price-origin');
    var variantInput = document.getElementById('pa-variant-id');
    var ctaBtn = document.getElementById('pa-add-to-cart');

    if (variant && variant.available) {
      var price = (variant.price / 100).toLocaleString('en-US', {
        minimumFractionDigits: 0, maximumFractionDigits: 0
      });
      priceEl.textContent = '$' + price;

      // Determinar origen para el subtítulo
      var originVal = variant.option3 || variant.option2 || '';
      if (originEl) {
        originEl.textContent = originVal.indexOf('Lab') !== -1 ? 'Lab-Grown' :
                               originVal.indexOf('Natural') !== -1 ? 'Natural' : '';
      }

      if (variantInput) variantInput.value = variant.id;
      if (ctaBtn) {
        ctaBtn.disabled = false;
        ctaBtn.textContent = '✦  Agregar al carrito';
      }
    } else {
      priceEl.textContent = 'No disponible';
      if (ctaBtn) {
        ctaBtn.disabled = true;
        ctaBtn.textContent = 'No disponible';
      }
    }
  }

  // ── Actualizar labels de selected value ──
  function updateLabels() {
    // Metal (siempre índice 0)
    var metalVal = document.getElementById('pa-metal-val');
    if (metalVal) metalVal.textContent = selected[0] || '';

    // Dimensión (Grosor u otro): recorre todos los índices de opciones
    // El liquid genera id="pa-dim-val-{opt_index}" solo para opciones tipo {% else %}
    for (var i = 1; i <= options.length; i++) {
      var dimVal = document.getElementById('pa-dim-val-' + i);
      if (dimVal) dimVal.textContent = selected[i - 1] || '';
    }

    // Talla (si el select existe, reflejar valor seleccionado)
    var tallaSelect = document.getElementById('pa-talla-select');
    if (tallaSelect && tallaSelect.value) {
      var tallaVal = document.getElementById('pa-talla-val');
      if (tallaVal) tallaVal.textContent = tallaSelect.value;
    }
  }

  // ── Deshabilitar botones de dimensión que no tienen variante disponible ──
  function updateDimAvailability() {
    var dimContainer = document.querySelector('.pa-dims');
    if (!dimContainer) return;

    dimContainer.querySelectorAll('.pa-dbtn').forEach(function(btn) {
      // Usa el data-option-index del propio botón para poner el valor en la posición correcta
      var btnIdx = parseInt(btn.dataset.optionIndex, 10) - 1; // 0-based
      var testSelected = selected.slice();                     // copia del estado actual
      testSelected[btnIdx] = btn.dataset.value;               // cambia solo esta posición
      var variant = findVariant(testSelected);
      if (!variant || !variant.available) {
        btn.classList.add('pa-dbtn--na');
      } else {
        btn.classList.remove('pa-dbtn--na');
      }
    });
  }

  // ── Handler genérico para todos los selectores de botón ──
  function handleSelection(optionIndex, value) {
    // optionIndex es 1-based desde el liquid (data-option-index)
    var idx = optionIndex - 1;
    selected[idx] = value;

    // Actualizar UI activos
    document.querySelectorAll('[data-option-index="' + optionIndex + '"]').forEach(function(btn) {
      if (btn.tagName === 'SELECT') return; // el select lo maneja su propio listener
      btn.classList.remove('pa-mbtn--active', 'pa-dbtn--active', 'pa-obtn--active');
      if (btn.dataset.value === value) {
        if (btn.classList.contains('pa-mbtn')) btn.classList.add('pa-mbtn--active');
        else if (btn.classList.contains('pa-dbtn')) btn.classList.add('pa-dbtn--active');
        else if (btn.classList.contains('pa-obtn')) btn.classList.add('pa-obtn--active');
      }
    });

    updateLabels();
    updateDimAvailability();
    var variant = findVariant(selected);
    updatePrice(variant);

    // Actualizar imagen principal al cambiar cualquier opción de variante
    if (variant && variant.featured_image && variant.featured_image.src) {
      var mainImgEl = document.getElementById('pa-main-img');
      if (mainImgEl) mainImgEl.src = variant.featured_image.src;
    }
  }

  // ── Event delegation — un solo listener para botones ──
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-option-index][data-value]');
    if (!btn) return;
    if (btn.tagName === 'SELECT') return;
    if (btn.classList.contains('pa-dbtn--na')) return;
    var idx = parseInt(btn.dataset.optionIndex, 10);
    handleSelection(idx, btn.dataset.value);
  });

  // ── Listener para select de Talla ──
  var tallaSelect = document.getElementById('pa-talla-select');
  if (tallaSelect) {
    tallaSelect.addEventListener('change', function() {
      var idx = parseInt(tallaSelect.dataset.optionIndex, 10);
      var value = tallaSelect.value;
      if (!value) return;
      // Actualizar label visible
      var tallaVal = document.getElementById('pa-talla-val');
      if (tallaVal) tallaVal.textContent = value;
      // Actualizar selected array
      selected[idx - 1] = value;
      updateDimAvailability();
      updateLabels();
      var variant = findVariant(selected);
      updatePrice(variant);
    });
  }

  // ── Selector de talla custom (bandas sin Talla como variante) ──
  document.querySelectorAll('.pa-tbtn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.pa-tbtn').forEach(function(b) {
        b.classList.remove('pa-tbtn--active');
      });
      btn.classList.add('pa-tbtn--active');
      var talla = btn.dataset.talla;
      var display = document.getElementById('pa-talla-display');
      if (display) display.textContent = talla + ' US';
      var input = document.getElementById('pa-talla-input');
      if (input) input.value = talla + ' US';
    });
  });

  // ── Thumbnails ──
  var mainImg = document.getElementById('pa-main-img');
  var imgCurrent = document.getElementById('pa-img-current');

  document.querySelectorAll('.pa-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      document.querySelectorAll('.pa-thumb').forEach(function(t) {
        t.classList.remove('pa-thumb--active');
      });
      thumb.classList.add('pa-thumb--active');
      if (mainImg && thumb.dataset.src) {
        mainImg.src = thumb.dataset.src;
      }
      if (imgCurrent) imgCurrent.textContent = thumb.dataset.index;
    });
  });

  // ── Add to cart con AJAX (sin reload) ──
  var form = document.getElementById('pa-form');
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var variantId = document.getElementById('pa-variant-id').value;
      if (!variantId) return;

      // Validar talla si el selector custom existe (bandas)
      var tallaInput = document.getElementById('pa-talla-input');
      if (tallaInput && !tallaInput.value) {
        alert('Por favor selecciona una talla');
        return;
      }

      var ctaBtn = document.getElementById('pa-add-to-cart');
      var origText = ctaBtn.textContent;
      ctaBtn.disabled = true;
      ctaBtn.textContent = 'Agregando...';

      var cartBody = { id: parseInt(variantId, 10), quantity: 1 };
      if (tallaInput && tallaInput.value) {
        cartBody.properties = { 'Talla': tallaInput.value };
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cartBody)
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        ctaBtn.textContent = '✓  Agregado al carrito';
        setTimeout(function() {
          window.location.href = '/cart';
        }, 600);
      })
      .catch(function() {
        ctaBtn.disabled = false;
        ctaBtn.textContent = origText;
      });
    });
  }

  // ── Init ──
  updateDimAvailability();
  updateLabels();

});
